var _style, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPazzle3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 195.6 116",
    style: {
      enableBackground: "new 0 0 195.6 116"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.2;fill:#41B9C3;enable-background:new    ;}\n\t.st1{fill:none;stroke:#41B9C3;stroke-linecap:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M188.2,115h-95c-4-4.5-11.5-41-1.5-34c8,5.6,17.7,3,21.5,1c2.7-2.2,7.3-8.8,4.5-18c-2.8-9.2-13.5-9.2-18.5-8 c-7.6,2.4-10.8,1.7-11.5,1c-0.8-19.2,3.7-29.7,6-32.5c4,2,19.7,6.2,27,8c8.8,0.8,7.7-6.3,6-10c-1.6-8-0.3-14,0.5-16 c0.5-4,11.5-10,20.5-4c7.2,4.8,6,14,4.5,18c-2.8,8.4,0.2,10.8,2,11c12,0.8,27-4.7,33-7.5l6.5,20.5c4.4,14.8-1.8,15.8-5.5,14.5 c-6-4-14.5-2.3-18-1c-8,5.2-6,15.8-4,20.5c3.6,8,12.5,6.7,16.5,5c3.2-3.6,8.7-3.2,11-2.5C198.9,90.6,192.2,107.7,188.2,115z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M58.2,56.9c-11.6-6-33.1-24.4-25.6-50.4 M32.6,6.4l-6.5,4.3 M32.6,6.4l4.3,5.8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPazzle3);
export default __webpack_public_path__ + "static/media/pazzle3.ef2cf005f06433b6843eb731ac9ebdce.svg";
export { ForwardRef as ReactComponent };